// Update an existing company asset

import api from '../api';

// Get assets assigned to an employee
export const fetchEmployeeAssets = async ({
  page,
  pageSize,
  search,
  filters,
  status,
  assigned_to,
}: {
  page: number
  search: string
  pageSize: number
  filters: { [key: string]: string[] }
  status: string
  assigned_to?: string
}) => {
  const params: Record<string, any> = {
    page,
    search,
    page_size: pageSize,
    expand: 'assigned_to',
    fields: '*,assigned_to.first_name,assigned_to.last_name,assigned_to.profile_picture,assigned_to.id',
    status: status,
    assigned_to: assigned_to,
  }
  Object.entries(filters).forEach(([key, values]) => {
    if (values.length > 1) {
      params[`${key}__in`] = values.join(',')
    } else if (values.length === 1) {
      params[key] = values[0]
    }
  })
  const res = await api.get('/assets/', { params })
  return res.data
}

// Create a new company asset
export const addAsset = async (assetData: any) => {
  const response = await api.post(`/assets/`, assetData);
  return response.data;
};

// Delete a company asset by ID
export const deleteCompanyAsset = async (assetId: number) => {
  const response = await api.delete(`/assets/${assetId}/`);
  return response.data;
};

export const updateAsset = async (assetId: string | number, assetData: any) => {
  const response = await api.patch(`/assets/${assetId}/`, assetData);
  return response.data;
};